import { render, staticRenderFns } from "./PwaProfile.vue?vue&type=template&id=0f57ce50&scoped=true"
import script from "./PwaProfile.vue?vue&type=script&lang=js"
export * from "./PwaProfile.vue?vue&type=script&lang=js"
import style0 from "./PwaProfile.vue?vue&type=style&index=0&id=0f57ce50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f57ce50",
  null
  
)

export default component.exports